import { httpGet } from '@/api/http';
import { V2_USERS_ME } from '@/constants/endpoint';
import type { UseQueryReturnType } from '@tanstack/vue-query';
import { mapToUser } from '@/api/useUsers';
import type { AxiosError } from 'axios';
import type { LoggedUser } from '@/stores/useUserStore';
import type { UserDTO } from '@/data/User';
import { useAuthenticatedQuery } from '@/utils/query';

export const LOGGED_IN_USER_QUERY_KEY = 'logged_in_user';

export const fetchLoggedInUser = () => httpGet<UserDTO>(V2_USERS_ME).then((r) => mapToUser(r));

export const useLoggedInUser = (): UseQueryReturnType<LoggedUser, AxiosError<unknown, any>> => {
  return useAuthenticatedQuery({
    queryKey: [LOGGED_IN_USER_QUERY_KEY],
    queryFn: () => fetchLoggedInUser(),
    retry: 3,
    retryDelay: 3_000,
    refetchInterval: 60_000,
  });
};
